/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { db } from "../firebaseConfig";
import { toast } from "react-hot-toast";
import { UserAuth } from "../context/authContext";
import { ec as EC } from "elliptic";
import { FaRegClipboard } from "react-icons/fa";
import { serverTimestamp } from "firebase/firestore";
import { clsx } from "clsx";
import { FiExternalLink, FiSearch, FiClock, FiDollarSign } from "react-icons/fi";
import { Link } from "react-router-dom";

const MemPool = () => {
  //   const { id } = useParams();
  const [roomId, setRoomId] = useState(localStorage.getItem("roomId") || "");
  const { userData } = UserAuth();
  const [hasAddedTransactions, setHasAddedTransactions] = useState(false);
  const [transactions, setTransactions] = useState([]);

  const generatePublicKeyFromPrivate = (privateKey) => {
    const ec = new EC("secp256k1");
    const keyPair = ec.keyFromPrivate(privateKey.slice(2), "hex");
    return "0x" + keyPair.getPublic(false, "hex").slice(2);
  };

  // Function to verify the sender's private key using the sender's public key
  const verifyPrivateKey = (senderPrivateKey, senderPublicKey) => {
    const generatedSenderPublicKey = generatePublicKeyFromPrivate(senderPrivateKey);
    return generatedSenderPublicKey === senderPublicKey;
  };

  const verifyTransaction = async (transaction) => {
    if (!roomId) return;

    try {
      const signature = transaction.signature;
      const matchResult = signature.match(/0x[a-fA-F0-9]{64}/g);

      // Extract the components
      const [receiverPublicKey, senderPrivateKey] = matchResult;

      const senderPublicKey = prompt(
        "Enter the sender's public key to verify the transaction, in order to verify the transaction signature using RSA.(Senders public key is required to verify the transaction signature)"
      );
      if (!senderPublicKey) {
        toast.error("Sender's public key is required to verify the transaction");
        return;
      }

      const isValidPrivateKey = verifyPrivateKey(senderPrivateKey, senderPublicKey);

      if (!isValidPrivateKey) {
        toast.error("Invalid sender's publick key");
        return;
      } else {
        // Update transaction verfied status by miner publicKey
        const res = await db
          .collection("rooms")
          .doc(roomId)
          .collection("transactions")
          .doc(transaction.id)
          .update({
            minerPublicKey: userData.publicKey,
            status: "Validate",
            verified: true,
          });
        toast.success("Sender's private key verified successfully");
      }
      fetchRoomTransactions();
    } catch (e) {
      console.error("Failed to vote:", e.message);
      toast.error("Failed to vote");
    }
  };

  const validateTransaction = async (transaction) => {
    if (!roomId) return;

    // check the users balance first
    const senderRef = db.collection("users").doc(transaction.senderEmail);
    const userSnapshot = await senderRef.get();
    const senderData = userSnapshot.data();
    if (!senderData) {
      toast.error("Sender not found");
      return;
    }

    // check if the miner is the verifier
    if (userData.publicKey !== transaction.minerPublicKey) {
      toast.error("You are not the verifier of this transaction");
      return;
    }

    try {
      // check the user balance and request transaction amount
      if (senderData.balance < transaction.amount) {
        toast.error("Insufficient balance");
        // update the transaction collection with the status of the transaction
        const res = await db
          .collection("rooms")
          .doc(roomId)
          .collection("transactions")
          .doc(transaction.id)
          .update({
            status: "failed",
            failedMessage: "Insufficient balance",
            validatedAt: serverTimestamp(),
          });
      } else {
        // update the transaction collection with the status of the transaction
        const res = await db
          .collection("rooms")
          .doc(roomId)
          .collection("transactions")
          .doc(transaction.id)
          .update({
            status: "Add to block",
            validatedAt: serverTimestamp(),
          });
        // deduct the sender's balance
        const newBalance = senderData.balance - transaction.amount;
        await senderRef.update({
          balance: newBalance,
        });
        toast.success("Validation successful!");
      }
    } catch (e) {
      console.error("Failed to vote:", e.message);
      toast.error("Failed to vote");
    }
  };

  const addTransactionToBlock = async (transaction) => {
    if (!roomId) return;
    // check transaction is verified or not
    if (!transaction.verified) {
      toast.error("Transaction not verified");
      return;
    }

    // check if transaction is status is pending
    if (transaction.status === "Validate") {
      toast.error("Transaction is pending, first verify and validate the transaction");
      return;
    }

    // check if transaction is status is failed
    if (transaction.status === "failed") {
      toast.error("Transaction is failed, cannot be added");
      return;
    }

    // check if transaction is already added to block
    if (transaction.blockStatus === "added") {
      toast.error("Transaction already added to block");
      return;
    }

    // check if the miner is the verifier of the transaction
    if (transaction.minerPublicKey !== userData.publicKey) {
      toast.error("You are not the verifier of this transaction");
      return;
    }

    try {
      // check for empty block collection
      const res = await db
        .collection("rooms")
        .doc(roomId)
        .collection("transactions")
        .doc(transaction.id)
        .update({
          blockStatus: "added",
          status: "Added to block",
          addedAt: serverTimestamp(),
        });
      toast.success("Transaction added to block successfully");
    } catch (e) {
      console.error("Failed to add transaction to block:", e.message);
      toast.error("Failed to add transaction to block");
    }
  };

  const updateActionState = (transaction) => {
    switch (transaction.status) {
      case "Verify":
        verifyTransaction(transaction);
        break;
      case "Validate":
        validateTransaction(transaction);
        break;
      case "Add to block":
        addTransactionToBlock(transaction);
        break;
    }
    fetchRoomTransactions();
  };

  const fetchRoomTransactions = async () => {
    if (!roomId) return;

    try {
      const roomRef = db.collection("rooms").doc(roomId);
      roomRef.collection("transactions").onSnapshot((snapshot) => {
        const data = [];
        snapshot.forEach((t) => {
          data.push({ id: t.id, ...t.data() });
        });
        setTransactions(data);
        const allAdded = data.every(
          (t) => t.status === "Added to block" || t.status === "Added to chain"
        );
        setHasAddedTransactions(allAdded);
      });
    } catch (error) {
      console.error("Error fetching room transactions:", error);
      toast.error("Error fetching room transactions.");
    }
  };

  useEffect(() => {
    if (roomId) fetchRoomTransactions();
  }, [roomId]);

  const copyToClipboard = (e, data) => {
    e.preventDefault(); // Prevent the default action associated with the event

    navigator.clipboard.writeText(data).then(
      () => {
        toast.success("Copied Successfully");
      },
      () => {
        toast.error("Failed to copy");
      }
    );
  };

  return (
    <div className="max-w-[1600px] space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold text-white tracking-tight">MemPool</h2>
          <p className="text-text-muted mt-1">
            Pending transactions for Room: <span className="text-primary font-mono">{roomId}</span>
          </p>
        </div>
      </div>

      <div className="glass-card overflow-hidden">
        <div className="overflow-x-auto text-sm text-left text-text-muted">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-white/5 bg-surface/50">
                <th className="p-4 font-semibold uppercase tracking-wider text-[10px]">Hash</th>
                <th className="p-4 font-semibold uppercase tracking-wider text-[10px]">Sender</th>
                <th className="p-4 font-semibold uppercase tracking-wider text-[10px]">Receiver</th>
                <th className="p-4 font-semibold uppercase tracking-wider text-[10px]">
                  Signature
                </th>
                <th className="p-4 font-semibold uppercase tracking-wider text-[10px]">
                  Timestamp
                </th>
                <th className="p-4 font-semibold uppercase tracking-wider text-[10px]">Amount</th>
                <th className="p-4 font-semibold uppercase tracking-wider text-[10px]">Status</th>
                <th className="p-4 font-semibold uppercase tracking-wider text-[10px] text-right">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {transactions
                .filter(
                  (transaction) =>
                    transaction.status !== "genisis" &&
                    transaction.status !== "Added to chain" &&
                    transaction.status !== "Added to block"
                )
                .map((transaction) => (
                  <tr
                    key={transaction.id}
                    className="border-b border-white/5 hover:bg-white/5 transition-colors group"
                  >
                    <td className="p-4">
                      <div className="flex items-center gap-2 group/field">
                        <div className="bg-surface/50 border border-white/5 rounded-lg px-2 py-1 text-xs font-mono max-w-[120px] truncate text-primary">
                          {transaction.hash}
                        </div>
                        <button
                          onClick={(e) => copyToClipboard(e, transaction.hash)}
                          className="opacity-0 group-hover/field:opacity-100 p-1.5 hover:bg-white/10 rounded-md transition-all text-text-muted"
                        >
                          <FaRegClipboard size={14} />
                        </button>
                      </div>
                    </td>
                    <td className="p-4">
                      <div className="flex items-center gap-2 group/field">
                        <div className="bg-surface/50 border border-white/5 rounded-lg px-2 py-1 text-xs font-mono max-w-[120px] truncate">
                          {transaction.sender}
                        </div>
                        <button
                          onClick={(e) => copyToClipboard(e, transaction.sender)}
                          className="opacity-0 group-hover/field:opacity-100 p-1.5 hover:bg-white/10 rounded-md transition-all text-text-muted"
                        >
                          <FaRegClipboard size={14} />
                        </button>
                      </div>
                    </td>
                    <td className="p-4">
                      <div className="flex items-center gap-2 group/field">
                        <div className="bg-surface/50 border border-white/5 rounded-lg px-2 py-1 text-xs font-mono max-w-[120px] truncate">
                          {transaction.receiver}
                        </div>
                        <button
                          onClick={(e) => copyToClipboard(e, transaction.receiver)}
                          className="opacity-0 group-hover/field:opacity-100 p-1.5 hover:bg-white/10 rounded-md transition-all text-text-muted"
                        >
                          <FaRegClipboard size={14} />
                        </button>
                      </div>
                    </td>
                    <td className="p-4">
                      <div className="flex items-center gap-2 group/field">
                        <div className="bg-surface/50 border border-white/5 rounded-lg px-2 py-1 text-xs font-mono max-w-[120px] truncate">
                          {transaction.signature}
                        </div>
                        <button
                          onClick={(e) => copyToClipboard(e, transaction.signature)}
                          className="opacity-0 group-hover/field:opacity-100 p-1.5 hover:bg-white/10 rounded-md transition-all text-text-muted"
                        >
                          <FaRegClipboard size={14} />
                        </button>
                      </div>
                    </td>
                    <td className="p-4 whitespace-nowrap text-xs text-text-muted">
                      {transaction.timestamp?.toDate
                        ? transaction.timestamp.toDate().toLocaleString()
                        : "Pending"}
                    </td>
                    <td className="p-4">
                      <span className="font-bold text-secondary">{transaction.amount} Coins</span>
                    </td>
                    <td className="p-4">
                      <span
                        className={clsx(
                          "px-2 py-1 rounded-full text-[10px] font-bold uppercase border",
                          transaction.status === "Verify"
                            ? "bg-yellow-500/10 text-yellow-500 border-yellow-500/20"
                            : transaction.status === "Validate"
                              ? "bg-blue-500/10 text-blue-500 border-blue-500/20"
                              : "bg-green-500/10 text-green-500 border-green-500/20"
                        )}
                      >
                        {transaction.status === "Verify"
                          ? "To Verify"
                          : transaction.status === "Validate"
                            ? "Verified"
                            : "Validated"}
                      </span>
                    </td>
                    <td className="p-4 text-right">
                      {transaction.status !== "Added to block" ? (
                        <button
                          onClick={() => updateActionState(transaction)}
                          className="bg-primary hover:bg-primary-hover text-white text-xs font-bold py-2 px-4 rounded-lg transition-all shadow-lg shadow-primary/20 active:scale-95 whitespace-nowrap"
                        >
                          {transaction.status === "Verify"
                            ? "Verify Now"
                            : transaction.status === "Validate"
                              ? "Validate TX"
                              : "Add to Block"}
                        </button>
                      ) : (
                        <div className="inline-flex items-center gap-2 text-green-500 text-xs font-bold">
                          <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
                          STAGED
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {transactions.filter(
          (transaction) =>
            transaction.status !== "genisis" &&
            transaction.status !== "Added to chain" &&
            transaction.status !== "Added to block"
        ).length < 1 && (
          <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
            <div className="w-20 h-20 bg-white/5 rounded-full flex items-center justify-center mb-6 border border-white/5">
              <FaRegClipboard size={32} className="text-text-muted opacity-50" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">No Transactions Found</h3>
            <p className="text-text-muted max-w-sm mb-8">
              The mempool is currently empty. There are no pending transactions waiting for mining
              or validation.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/blocks"
                className="px-6 py-3 bg-white/5 border border-white/10 rounded-xl text-white font-semibold hover:bg-white/10 transition-all"
              >
                View My Blocks
              </Link>
              <Link
                to="/joinedroom"
                className="px-6 py-3 bg-primary rounded-xl text-white font-semibold hover:bg-primary-hover transition-all shadow-lg shadow-primary/20"
              >
                Return to Dashboard
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MemPool;
